import { render } from "./recommended-products.vue?vue&type=template&id=031addd0"
import script from "./recommended-products.vue?vue&type=script&lang=js"
export * from "./recommended-products.vue?vue&type=script&lang=js"

import "./recommended-products.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__